import { TokenValidity } from "../@types/TokenValidity";
import { ErrorCodes } from "../@types/ErrorCodes";
import { ErrorResponse, InvitationInformationResponse } from "../@types/api";

export default async function validateToken(
  token: string | null,
): Promise<TokenValidity> {
  if (token === null || token.trim().length === 0) {
    return { status: "error", code: ErrorCodes.E0101 };
  }

  let response: Response;
  try {
    response = await callApi(token);
  } catch (e) {
    return { status: "error", code: ErrorCodes.E0002, displayToast: true };
  }

  switch (response.status) {
    case 200:
      return handleSuccess(response);
    case 400:
      return handleError(response);
    case 401:
      return { status: "error", code: ErrorCodes.E0101 };
    case 403:
      return { status: "error", code: ErrorCodes.E0101 };
    default:
      return { status: "error", code: ErrorCodes.E0002, displayToast: true };
  }
}

async function handleSuccess(response: Response): Promise<TokenValidity> {
  const responseData = (await response.json()) as InvitationInformationResponse;
  return {
    status: "ok",
    data: responseData,
  };
}

async function handleError(response: Response): Promise<TokenValidity> {
  const err = (await response.json()) as ErrorResponse;
  return { status: "error", code: err.errorCode };
}

async function callApi(token: string): Promise<Response> {
  const url = new URL(window.REACT_APP_API_URL + "/start-registration");

  return fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}
